import { createI18n, type I18nOptions } from 'vue-i18n'

import { locales } from '@last/core-ui/paprika'

import ca from '@/locales/ca.json'
import de from '@/locales/de.json'
import en from '@/locales/en.json'
import es from '@/locales/es.json'

const availableLocales = ['en', 'es', 'ca', 'de']

const defaultLocale = () => {
  const browserLang = window.navigator.language.split('-')[0]
  return availableLocales.includes(browserLang) ? browserLang : 'en'
}

const options: I18nOptions = {
  legacy: false,
  globalInjection: true,
  locale: defaultLocale(),
  availableLocales,
  fallbackLocale: 'en',
  fallbackWarn: false,
  messages: {
    en: {
      ...locales.en,
      ...en
    },
    es: {
      ...locales.es,
      ...es
    },
    ca: {
      ...locales.ca,
      ...ca
    },
    de: {
      ...locales.de,
      ...de
    }
  }
}

const i18n = createI18n<false, typeof options>(options)

export default i18n

export const t = i18n.global.t
